// extracted by mini-css-extract-plugin
export default {"playerBox":"index_playerBox_uUQWO","playerContainer":"index_playerContainer_4IHfo","min_playerContainer":"index_min_playerContainer_Z6lLi","playerSeo":"index_playerSeo_qczg1"};